import React, { useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Field } from 'formik';
import { Select } from '@material-ui/core';
import CommonContainer from '../../containers/Common';

interface Props {
  meganetLensMasterId: number | undefined,
  name: string,
  onChange: (meganetLensMasterId: number) => void,
}

export default ((props) => {
  const commonContainer = CommonContainer.useContainer();
  const meganetLensMasterId = props.meganetLensMasterId || commonContainer.getDefaultLensMasterId(1);
  useEffect(() => {
    if (props.meganetLensMasterId === undefined) {
      props.onChange(meganetLensMasterId);
    }
  }, []);

  return (
    <Field style={{ fontSize: 13, }} required fullWidth name={props.name} label='Lens' id={props.name} value={meganetLensMasterId} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => props.onChange(Number(event.target.value))} component={Select} >
      {commonContainer.getLensesByMasterId(meganetLensMasterId).map(lens => (
        lens.lensType === 1 && <MenuItem key={lens.meganetLensMasterId} value={lens.meganetLensMasterId}>{lens.lensName}</MenuItem>)
      )}
    </Field >
  );
}) as React.FC<Props>;
